import React from "react";

const EducationCard = ({heading, subHeading, details, percentage, timePeriod}) => {
    return (
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0 text-primary">{heading}</h3>
          <div class="subheading">{subHeading}</div>
          <div class="mb-3">{timePeriod}</div>
          <div>{details}</div>
          <p>{percentage}</p>
        </div>
      </div>
    );
}

export default EducationCard

